import { useEffect } from 'react';
import { useServices } from './use-services';

export function useLoading(isLoading: boolean): void {
  const { loadingService } = useServices();

  useEffect(() => {
    if (!isLoading) {
      return;
    }

    ++loadingService.loadingCount;
    return () => {
      --loadingService.loadingCount;
    };
  }, [isLoading]);
}
